// Shown wherever the last remaining office is blocked from deletion (delete
// modal body, Delete Office button tooltip). This frontend guard ships ahead
// of the backend one, so ENG-1801's 409 body matches this string rather than
// the other way around — keep the two identical.
export const LAST_OFFICE_MESSAGE =
  "You must have at least one office location in Monolith.";

// Shown in those same places when the offices list could not be read, so the
// UI never claims "last office" for what is really an unknown count.
export const OFFICE_COUNT_UNAVAILABLE_MESSAGE =
  "Could not confirm how many offices exist. Please try again.";
